// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"718":"b1362a02","986":"67baa427"}[chunkId] + ".css";
};